import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';

@Component({
  selector: 'app-new-ticket-button',
  templateUrl: './new-ticket-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'shrink-0' },
})
export class NewTicketButtonComponent {
  readonly buttonClass = input<string>('');
  readonly iconOnly = input<boolean>(false);
  readonly create = output<void>();

  public images = images;
  public TooltipPosition = TooltipPosition;

  constructor(public literalService: LiteralService) {}
}
